var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    rx: 8,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 7.5,
    stroke: "#D7D7D9",
    strokeOpacity: 0.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_573_19410)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6673 15.3863V15.9996C22.6665 17.4372 22.201 18.836 21.3402 19.9875C20.4794 21.1389 19.2695 21.9812 17.8909 22.3889C16.5123 22.7965 15.0388 22.7475 13.6903 22.2493C12.3418 21.7511 11.1904 20.8303 10.408 19.6243C9.6255 18.4183 9.25385 16.9916 9.34844 15.5571C9.44303 14.1226 9.99879 12.7571 10.9328 11.6643C11.8669 10.5715 13.1292 9.80984 14.5314 9.49301C15.9337 9.17619 17.4008 9.32114 18.714 9.90625M22.6673 10.6663L16.0007 17.3396L14.0007 15.3396",
    stroke: "#4C5068",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_573_19410"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.f808799f65bdc28949595fc0b162901f.svg";
export { ForwardRef as ReactComponent };